var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('external_member_customer_bind.bypass_remind.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('thanks_page.step_section.steps')
    }
  })], 1) : _vm._e(), _vm.getModuleConfig('external_member_customer_bind.bypass_remind.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("external_member_customer_bind.bypass_remind.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('external_member_customer_bind.bypass_remind.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("external_member_customer_bind.bypass_remind.form_desc")) + " ")]) : _vm._e(), _vm.contentData ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.contentData)
    }
  }) : _vm._e(), _vm._l(_vm.contentImages, function (image) {
    return _c('img', {
      key: image.order,
      staticClass: "w-100",
      attrs: {
        "src": image.image_url
      }
    });
  }), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('div', [_vm.showRedirectButton && !_vm.redirectAction ? _c('SharedButton', {
    staticClass: "s-btn-outline-primary bg-transparent",
    on: {
      "click": _vm.redirectToIntended
    }
  }, [_vm._v(" " + _vm._s(_vm.redirectActionConfig.button_text) + " ")]) : _vm._e(), _vm.redirectAction && _vm.showRedirectButton ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.redirectActionConfig.button_text,
      "type": _vm.redirectAction
    }
  }) : _vm._e()], 1), _vm.showSuccessButton ? _c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('external_member_customer_bind.bypass_remind.button_text'),
      "button-url": _vm.getModuleConfig('external_member_customer_bind.bypass_remind.button_url'),
      "type": _vm.getModuleConfig('external_member_customer_bind.bypass_remind.button_action')
    }
  }) : _vm._e()], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }